<template>
  <div class="main-content sn-content">

      <el-card class="box-card">
        <div>
          <div class="vertical">
            <i class="el-icon-circle-check pvt-color"></i>
            <span class="secure-title">登录密码</span>
          </div>
          <p class="tag" style="">安全性高的密码可以使账号更安全。建议您定期更换密码，设置一个包含字母、符号或数字中至少两项且长度超过6位的密码。 您已绑定了手机</p>

          <router-link :to="{path:'/uac/updatePassword'}" class="pvt-color" style="float: right;margin-top: -20px">修改密码</router-link>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="vertical">
            <i class="el-icon-circle-check pvt-color"></i>
            <span class="secure-title">手机绑定</span>
          </div>
          <p class="tag" style="">
            <span>您已绑定了手机</span>
            <span  class="pvt-color">{{user.mobile}}</span>
            您的手机号为安全手机，可以找回密码
          </p>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="vertical">
            <i class="el-icon-circle-check pvt-color"></i>
            <span class="secure-title">密钥管理</span>
          </div>
          <p class="tag" style="">

            是您安全访问托管应用，安全使用SDK授权的凭证，请您妥善保管。
          </p>
          <router-link :to="{path:'/uac/larkXRClientCredential'}" class="pvt-color" style="float: right;margin-top: -20px">去设置</router-link>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="vertical">
            <i class="el-icon-circle-check pvt-color"></i>
            <span class="secure-title">费用预警</span>
          </div>
          <el-row v-if="!showCreditUI" class="credit-row">
            <span>费用预警阈值(元):</span>&nbsp;
            <span class="pvt-color">{{lineOfCredit}}</span>
          </el-row>
          <div v-if="showCreditUI">
            <span class="credit-span">费用预警阈值(元):</span>&nbsp;
            <el-input class="credit-input" size="small" v-model="lineOfCredit" placeholder="请输入提醒金额"></el-input>
            <span class="tag" style="">
              请输入10-10000的整数
            </span>
            <div class="credit-save">
              <el-button size="mini" @click="showCreditUI = false;">取消</el-button>
              <el-button type="primary" size="mini" @click="save">保存</el-button>
            </div>
          </div>
          <el-button v-if="!showCreditUI" type="text" class="pvt-color" style="float: right;margin-top: -20px;z-index: 2;" @click="showCreditUI = true;">修改</el-button>
        </div>
        <el-divider></el-divider>
       <!-- <div>
          <div class="vertical">
            <i v-if="user.email" class="el-icon-circle-check main-color"></i>
            <i v-else class="el-icon-warning-outline" style="color: orange"> </i>
            <span class="secure-title">备用邮箱</span>
          </div>
          <p class="tag" style="">
            <span>您
            <span style="color: #FE9A64">未绑定</span>备用邮箱[备用邮箱绑定后可用来接收平行云发送的各类系统、营销、服务等通知]</span>
            <span class="main-color-deep pointer" @click="">现在绑定</span>

          </p>
        </div>
        <el-divider></el-divider>-->
      </el-card>

  </div>
</template>

<script>
  import {Message} from "element-ui";

  export default {
    data() {
      return {
        lineOfCredit: null,
        showCreditUI: false,
        lineOfCreditInfo: {}
      }
    },
    created() {
      this.getOutofcredititem();
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getOutofcredititem() {
        this.getRequest('/ofcOutOfCreditItem/getByUserId', {userId: this.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              if(resp.data.result){
                this.lineOfCreditInfo = resp.data.result;
                this.lineOfCredit = this.lineOfCreditInfo.lineOfCredit;
              }

            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      save() {
        const re = /^[0-9]*[1-9][0-9]*$/;
        const rsCheck = re.test(Number(this.lineOfCredit));
        if(!this.lineOfCredit) {
          Message.error('请输入费用预警值！');
          return
        } else if(!rsCheck) {
          Message.error('请输入正整数！');
          return
        } else if(Number(this.lineOfCredit) < 10 || Number(this.lineOfCredit) > 10000) {
          Message.error('请输入[10,10000]的正整数！');
          return
        } else {
          if(this.lineOfCreditInfo.id === '879770861261811111') {
            this.addLineOfCredit();
          } else {
            this.updateLineOfCredit();
          }
        }
      },
      addLineOfCredit() {
        let params = {
          lineOfCredit: this.lineOfCredit,
          userId: this.user.userId
        }
        console.log(params)
        this.postRequestJson('/ofcOutOfCreditItem/add', JSON.stringify(params)).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              Message.success('保存成功！');
              this.showCreditUI = false;
              this.getOutofcredititem();
            }
          }
        })
      },
      updateLineOfCredit() {
        let params = {
          lineOfCredit: this.lineOfCredit,
          id: this.lineOfCreditInfo.id
        }
        this.postRequestJson('/ofcOutOfCreditItem/update', JSON.stringify(params)).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              Message.success('修改成功！');
              this.showCreditUI = false;
              this.getOutofcredititem();
            }
          }
        })
      }
    },
    mounted: function () {

    },
    beforeDestroy() {

    }
  }
</script>
<style lang="scss" scoped>
.credit-row {
  margin-top: 15px;
  margin-left: 24px;
  color:#9F9F9F;
  width: 90%;
  >span:nth-of-type(2) {
    // margin-right: 80px;
    display: inline-block;
  }
}
.credit-save {
  margin-left: 24px;
  margin-top: 10px;
}
.credit-span {
  margin-left: 24px;
  display: inline-block;
}
.credit-input {
  width: 230px;
  margin-top: 10px;
  // margin-left: 24px;
}
</style>
